import DonationSummary from '3-components/Donations/DonationSummary/DonationSummary';
import type { ReactNode } from 'react';
import { useDonationStore } from '../libs/useDonationStore';
import { useDonationBlockProps, type DonationSummaryLabelProps } from '../DonationBlockProvider';
import InlineMessage from '3-components/InlineMessage/InlineMessage';
import { formatPrice } from 'utils/formatPrice';

const DonationSummaryBox = ({ children }: {children?: ReactNode}): JSX.Element => {
    const { donationData, getTotalAmount } = useDonationStore();
    const { summaryLabels, donationConfig } = useDonationBlockProps();

    if (!summaryLabels) {
        return (
            <InlineMessage status="error">
                Please configure summary labels
            </InlineMessage>
        );
    }

    const currentSummaryLabels: DonationSummaryLabelProps = summaryLabels[donationData.frequency];
    const summaryAmount = formatPrice(donationData.amount.toString(), donationConfig?.currency, donationConfig?.currencySymbol);
    const summaryFee = formatPrice(donationData.fee.toString(), donationConfig?.currency, donationConfig?.currencySymbol);
    const totalDonation = formatPrice(getTotalAmount().toString(), donationConfig?.currency, donationConfig?.currencySymbol);

    const summaryDonationItems = [
        {
            itemLabel: currentSummaryLabels.giftTypeLabel,
            itemValue: currentSummaryLabels.giftTypeValue,
        }, {
            itemLabel: currentSummaryLabels.amountLabel,
            itemValue: summaryAmount,
        }
    ];

    const summaryDonationFeeItem = donationData.fee ? [
        {
            itemLabel: currentSummaryLabels.feeLabel,
            itemValue: summaryFee,
        }
    ] : [];

    const summaryItems = summaryDonationItems.concat(summaryDonationFeeItem);

    const footerSummaryItems = [
        {
            itemLabel: currentSummaryLabels.totalLabel,
            itemValue: totalDonation,
        }
    ];

    return (
        <DonationSummary
            summaryTitle={currentSummaryLabels.summaryTitle}
            summaryItems={summaryItems}
            summaryFooterItems={footerSummaryItems}
        >
            {children}
        </DonationSummary>
    );
};

export default DonationSummaryBox;
